import { Vector3 } from 'three';

declare module 'three' {
  interface Vector3 {
    transformPosition(): Vector3;
  }
}

Vector3.prototype.transformPosition = function () {
  this.x = -this.x;
  return this;
};

export { };
